import React from 'react';
import {makeStyles} from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from '@material-ui/core/Tooltip';
import { RepeatGlobalIcon2 } from 'common/ui/icons';
import { longNumberString, shortNumberString } from 'common/utils';

const useStyles = makeStyles((theme) => ({
    iconButton: {
        border: 10,
        borderRadius: '50%',
        boxSizing: 'border-box',
        display: 'inline-block',
        fontFamily: 'Roboto',
        '-webkit-tap-highlight-color': 'rgba(0, 0, 0, 0)',
        cursor: 'pointer',
        textDecoration: 'none',
        padding: '0px',
        outline: 'none',
        fontSize: '0px',
        fontWeight: 'inherit',
        position: 'relative',
        overflow: 'visible',
        transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
        width: 'auto',
        fill: 'rgb(176, 176, 176)',
        background: 'none',
    },
    icon: {
        color: '#B0B0B0',
        width: 18,
        height: 18,
        fontSize: 12,
        verticalAlign: 'bottom',
        display: 'inline',
        marginRight: 3,
        borderRadius: '50%',
    },
    spanText: {
        fontFamily: 'Arial',
        paddingLeft: 2,
        fontSize: 12,
        verticalAlign: 'bottom',
        display: 'inline',
        color: 'rgb(176, 176, 176)'
    }
}));

const GlobalClick = (props) => {
    const classes = useStyles();

    const clicks = props.globalClick || 0;
    const repeatsTooltip = `Global Clicks: ${longNumberString(
        clicks
    )}`;

    return(
        <Tooltip title={repeatsTooltip}>
            <IconButton className={classes.iconButton}>
                <RepeatGlobalIcon2 className={classes.icon} />
                <span className={classes.spanText}>{shortNumberString(clicks)}</span>
            </IconButton>
        </Tooltip>
    );
};

export default GlobalClick;